import { InertiaLink, usePage } from '@inertiajs/inertia-react'
import AppLayout from '@/Layouts/AppLayout'
import AdminLayout from '@/Layouts/AdminLayout'
import { useTitle } from '@/Utilities/Hooks'
import { Container } from '@/Components/'

export default function BasicPage({
  organization,
}) {
  useTitle('Terms of service')

  return (
    <Container className="relative flex flex-col overflow-visible flex-wrapmax-w-5xl md:flex-row">
      <div className="flex flex-col items-stretch justify-start">
        <div className="mb-4">
          <div className="inline-flex items-center pb-2">
            <InertiaLink className="text-blue-800 underline hover:no-underline" href="/emissions">
              <span>Emission accounting</span>
            </InertiaLink>
            <span className="mx-3">/</span>
            <span className="">About</span>
          </div>
        </div>

        <div className="w-full ">
          <h1 className="mb-4 header-1">Text page</h1>

          <p className="mb-4 text-typo">Utsläppen av växthusgaser måste minska drastiskt om vi ska nå uppvärmningsmålet i Parisavtalet. För att begränsa uppvärmningen till 1,5C krävs utsläppsminskningar motsvarande 65% vilket innebär att nationella åtaganden inom EU måste femfaldigas. Detta konstaterades på EUs klimatmöte på femårsdagen av Parisavtalet i december 2020. EUs mål idag är att sänka utsläppen med 55% till år 2030.</p>
          <p className="mb-4 text-typo">Företag och andra organisationer har en viktig roll i arbetet med att sänka utsläppen.</p>

          <h3 className="mb-4 text-xl font-bold text-typo">Gidås definition av hållbarhet</h3>
          <p className="mb-4 text-typo">Hållbarhet handlar om långsiktighet och om att blicka framåt. En kombination av budskap, känsla och handling.  Hållbarhet är också en trend om att ligga i framkant och utmana traditionella affärsmodeller. Det handlar om goda affärer i dag och för framtiden. Tillsammans hjälper vi dig hitta rätt på den komplexa hållbarhetsagendan.</p>
          <InertiaLink className="inline-block mb-4 btn-blue" href="/emissions">Read all about it</InertiaLink>

          <h2 className="mb-4 text-lg text-typo">Vi kan hållbarhetdata</h2>

          <p className="mb-4 text-typo">Koldioxidutsläpp, antal anställda eller energiförbrukning är alla viktiga nyckeltal  som kan synliggöras i en hållbarhetsredovisning eller hållbarhetsrapport. Vi hjälper dig på ett enkelt och flexibelt sätt hålla reda på allt. Dessutom har vi tillgång till viktiga omräkningsfaktorer, databaser och statistik. På så vis kan vi ta fram dina viktigaste nyckeltal snabbt och effektivt. </p>

          <ul className="unordered-list">
            <li><p className="mb-4 text-typo">Oavsett om du behöver en fullständig hållbarhetsredovisning, extra kvalitetssäkring av nyckeltal eller bara lite inspiration så hjälper vi dig. </p></li>
            <li><p className="mb-4 text-typo">Vi har kunskap på områden som standardramverk, hållbarhetslagen, utsläppsberäkningar, infografik och design. Vårt mål är att vara flexibla, pålitliga och snabba i vår leverans. </p></li>
            <li><p className="mb-4 text-typo">Vi är transparenta i vår prissättning och du bestämmer hela vägen.</p></li>
          </ul>

          <p className="mb-4 text-typo">Emma står för emission accounting och är ett klimatverktyg som samlar all din klimatdata och kopplar din data till bokföringen. Spara resurser, effektivisera och få en daglig överblick över ert hållbarhetsarbete.</p>

        </div>

      </div>
    </Container>

  )
}

BasicPage.layout = page => (
  <AppLayout>
    <AdminLayout>{page}</AdminLayout>
  </AppLayout>
)
